/* eslint-disable max-len */
/* eslint-disable no-useless-computed-key */

import { ImageProvider, ImageSearchMode } from './../../../ui';
import React from 'react';
import styled from 'styled-components';

const defineMode = (key: string, label: string) => ({ key, label });

const PixabayLogo = () =>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 123.87">
        <g fill="currentColor">
            <path d="M523.51 40.17c-3.48-2.47-6-4.96-6-8.04h-19.34c0 5.54-2.53 8.04-5.64 8.04h-5.17V96.4h100.42V40.17h-64.63zm-6 16.06h-18.1V48.2h20.09v6.46zm33.99 31.28c-11.46 0-20.78-9.2-20.78-20.51s9.32-20.04 20.78-20.04 20.78 8.72 20.78 20.04c0 11.3-9.32 20.5-20.78 20.5zM562.67 67c0 6.08-5.01 11.02-11.17 11.02A11.11 11.11 0 01540.33 67c0-6.09 5.01-11.03 11.17-11.03s11.17 4.95 11.17 11.03zM640 32.52l-25 63.73-19.18-7.7V77.7l13.32 5.45 17.6-44.85-65.93-25.2-6.1 19.03h-11L554.94 0 640 32.52z" />
            <path d="M33.95 28.5c16.56-.37 32.1 13.1 33.86 29.61 2.09 14.52-6.45 29.6-19.83 35.48-8.1 4.03-17.26 2.79-25.98 3h-8.52v27.29H-.02c.04-21.06-.05-42.12.05-63.18.44-15.68 13.29-29.73 28.8-31.82 1.7-.25 3.41-.38 5.12-.37zm0 54.59c9.74.24 18.86-7.35 20.32-17C56.2 56.4 50 45.97 40.55 43.06c-9.14-3.24-20.14 1.03-24.6 9.66-3.47 5.9-2.24 12.87-2.47 19.37v11.01h20.47zM74.33 28.18h13.34v68.08H74.33V28.18zM127.76 71.16h.49l18.96 25.28h16.53l-25.77-35 22.86-33.07H144.3l-16.05 23.34h-.49l-16.04-23.34H95.19l22.85 33.07-25.77 35h16.53z" />
            <path d="M193.95 28.18c13.51-.27 26.47 8.58 31.47 21.08 2.62 5.8 2.58 12.23 2.5 18.46v28.54c-12.05-.05-24.09.08-36.13-.07-13.84-.67-26.5-10.77-30.46-24.01-3.63-11.52-.62-24.89 7.94-33.49a34.37 34.37 0 0124.68-10.51zm20.47 54.58c-.06-7.57.12-15.14-.1-22.7-.8-10.15-10.19-18.65-20.37-18.39-9.67-.23-18.8 7.28-20.31 16.86-1.78 9.2 3.5 19.21 12.28 22.64 5.4 2.36 11.37 1.39 17.08 1.6h11.42zM268.52 28.5c15.98-.39 30.91 12.19 33.46 27.92 2.89 14.92-5.54 31.03-19.43 37.17-13.57 6.4-31.02 2.28-40.36-9.46-5.78-6.81-8.28-15.87-7.78-24.7V1.21h13.49V28.5h20.62zm0 54.59c10.25.27 19.62-8.33 20.37-18.53 1.29-10.13-6.23-20.32-16.26-22.16-5.54-.76-11.18-.25-16.76-.4h-7.97c.09 7.7-.18 15.4.16 23.08 1.07 10.16 10.26 18.2 20.46 18zM341.65 28.18c13.51-.27 26.47 8.58 31.47 21.08 2.61 5.8 2.58 12.23 2.5 18.46v28.54c-12.05-.05-24.1.08-36.13-.07-13.84-.67-26.5-10.77-30.46-24.01-3.64-11.52-.62-24.89 7.93-33.49a34.37 34.37 0 0124.69-10.51zm20.47 54.58c-.06-7.57.12-15.14-.1-22.7-.8-10.15-10.2-18.65-20.37-18.39-9.68-.23-18.8 7.28-20.32 16.86-1.77 9.2 3.5 19.21 12.28 22.64 5.4 2.36 11.38 1.39 17.09 1.6h11.42zM449.87 28.34c-.03 21 .06 42.02-.04 63.02-.5 16.54-14.7 31.4-31.29 32.26-3.15.17-6.3.06-9.46.1v-13.5c5.76-.03 11.92.56 17.02-2.7a20.6 20.6 0 0010.27-18.07c-11.96 9.64-30.5 9.14-42.13-.81-8.47-6.84-13.1-17.85-12.45-28.68V28.34h13.5c.05 12.02-.13 24.05.1 36.06.72 9.9 9.55 18.27 19.46 18.5 10.05.78 19.72-7.03 21.22-16.96.6-5.95.17-11.96.3-17.93V28.34h13.5z" />
        </g>
    </svg>;

const PixabayText = styled.div`
    color: #6b7280;
    font-size: 1rem;
    line-height: 2.5rem;
    
    svg {
        position: relative;
        top: 0.6rem;
        height: 1.2rem;
        margin-left: 0.3rem;
    }
`;

// sw.span({
//     base: ['inline-flex', 'items-center', 'font-bold', 'text-sm', 'text-gray-500'],
//     ['svg']: ['relative', 'h-4', 'ml-1', 'top-px']
// });

const PixabayLicense = () =>
    <PixabayText>
        All images provided royalty free by
        <a href="https://pixabay.com/service/license/" rel="noopener noreferrer" target="_blank">
            <PixabayLogo />
        </a>
    </PixabayText>;

export const PixabayProvider: ImageProvider = {
    ui: {
        license: PixabayLicense
    },
    getSearchModes: () => [
        defineMode('all', 'All Images'),
        defineMode('photo', 'Photo'),
        defineMode('illustration', 'Illustration'),
        defineMode('vector', 'Vector'),
    ],
    search: async (query: string, page: number, mode?: ImageSearchMode | null) => {
        const type = mode ? mode.key : 'all';
        const call = `https://pixabay.com/api/?key=16160473-f6aece274375453581455a214&q=${query}&image_type=${type}&page=${page}&per_page=36`;
        const resp = await fetch(call).then(x => x.json());

        const items = resp.hits.map((x: any) => ({
            key: x.id,
            thumbUrl: x.webformatURL,
            url: x.largeImageURL,
            width: x.imageWidth,
            height: x.imageHeight,
        }));

        const hasMore = items.length === 36;

        return { items, hasMore };
    },
};
